import { Component, OnInit, AfterViewChecked, ViewChild, ElementRef  } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { debounce } from 'rxjs/operators/debounce';
import { TranslateService } from '@ngx-translate/core';
import { APPCONFIG } from '../../config';
import { AuthenticationService, DevedorService, LoadingService, LogSistemaService } from "../../services";
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit, AfterViewChecked  {
  model: any = {};
  devedor: any = {};
  devedorlogin: any = [];
  loading = false;
  error = '';
  loginStepOne = true;
  subUsuario: Subscription;
  _loading: any;
  subDevedor: Subscription;
  subParams: Subscription;
  clienteid: number;
  @ViewChild('inputdigitos') public inputdigitos: ElementRef;  
  
  idiomas: any = [
    {
      id: 'pt-BR',
      icon: '../assets/images/languages/pt-BR.svg'
    },
    {
      id: 'en',
      icon: '../assets/images/languages/en-US.svg'
    },
    {
      id: 'es',
      icon: '../assets/images/languages/es.svg'
    }];

  constructor(
    private router: Router
    , private activatedRoute: ActivatedRoute
    , private translate: TranslateService
    , private authenticationService: AuthenticationService
    , private devedorService: DevedorService
    , private loadingService: LoadingService
    , private _logSistema: LogSistemaService
  ) {
    this.model.idioma = translate.getBrowserLang() === "pt" ? "pt-BR" : translate.getBrowserLang();
    this.onChangeIdoma(this.model.idioma);
    this._loading = loadingService;    
    this.activatedRoute.queryParams
      .subscribe(params => {
        let refresh_token = params['refresh_token'];
        if (refresh_token)
          this.login(refresh_token)
      });
  }

  onChangeIdoma(idioma) {
    this.model.idioma = idioma;
    this.translate.use(idioma);
  }

  onChangeDigito(indice, radiodevedor, inputdigito) {    
    radiodevedor.checked = true;
    Array.from(this.devedorlogin).forEach((dev, idx) => {      
      if (idx == indice)  {                    
        this.devedorlogin[idx].checked = true;   
        inputdigito.focus();     
      }
      else 
      {
        this.devedorlogin[idx].checked = false;   
        this.devedorlogin[idx].digitos = '';  
      }   
    });    
  }

  onChangeDevedor(inputdigito, radiodevedor)
  {      
    Array.from(this.devedorlogin).forEach((dev, id) => {                               
      if (id != radiodevedor.id)                        
          this.devedorlogin[id].digitos = '';  
    }); 
    inputdigito.focus();
  }  

  ngOnInit() {    

   this.activatedRoute.params
    .subscribe((params: Params) => {
        this.clienteid = params['id'];                     
    });
    
    if(this.clienteid != undefined){
      this.setloginStepTwo();
      localStorage.setItem('loginWizard', "true");
    } else
      localStorage.setItem('loginWizard', "false");

    this.authenticationService.logout();
  } 

  ngAfterViewChecked() {   
    if(!this.loginStepOne) {
      if(this.inputdigitos != undefined){
        if(this.inputdigitos.nativeElement != undefined){
          this.inputdigitos.nativeElement.focus();
        }
      }
    }
 }

  login(form, refresh_token: string = null) {    

    this.loading = true;
    this._loading.carregar();    
    if(this.model.numero == undefined) {
      this.model.numero = this.model.ddd.trim() + this.model.telefone.trim();
    }
    
    this.authenticationService.login(form.digitos, this.model.numero, refresh_token).subscribe(() => {
      this.subUsuario = this.devedorService.getDevedorLogado().subscribe(result => {
        if (result) {
          localStorage.setItem('currentUserCobranca', JSON.stringify({ cpfCnpj: result.cpfCnpj, nome: result.nome, telefone: this.model.numero, devId: result.id, validacaoDados: false, language: this.model.idioma, token: this.authenticationService.token, refresh_token: this.authenticationService.refresh_token, clienteid: result.externoId }));
          
          if(this.clienteid > 0){
            this.router.navigate(['/app/w']);
          } else {
            this.router.navigate(['/']);
          }

          this._loading.fecharTodos();
          this.gravaLog("login");
        }
      });
    },
      err => {
        console.log(err);
        let _erro = JSON.parse(err._body);
        this.error = _erro.error_description;
        this.loading = false;
        this._loading.fecharTodos();
      });    
  }

  setloginStepOne() {
    this.loginStepOne = true;
  }

  setloginStepTwo() {    
    this.loading = true;         
    this._loading.carregar();

    if(this.clienteid != undefined){        

      this.subDevedor = this.devedorService.getDevedorPorClienteId(this.clienteid).subscribe(result => {
        if (result.length <= 0) {
          this.error = "Cliente não localizado. Tente novamente.";
          return;
        }  
        this.devedorlogin = result;
        this.model.numero = this.devedorlogin[0].numeroTelefone;
        this.devedorlogin[0].checked = true;
      });     

    } else {

      if (this.model.ddd == undefined || this.model.ddd == "" || this.model.telefone == undefined || this.model.telefone == "") {
        this.error = "Por favor, digite DDD e Telefone";
        return;
      }        
  
      this.subDevedor = this.devedorService.getDevedorPorTelefone(this.model.ddd.trim() + this.model.telefone.trim()).subscribe(result => {
        if (result.length <= 0) {
          this.error = "Telefone não localizado. Tente novamente.";
          return;
        }  
        this.devedorlogin = result;
        this.devedorlogin[0].checked = true;
      });
    }
    this.loading = false;
    this._loading.fecharTodos();
    this.error = "";    
    this.loginStepOne = false;     
  }

  ngOnDestroy() {
    if (this.subUsuario) this.subUsuario.unsubscribe();
    if (this.subDevedor) this.subDevedor.unsubscribe();
  }

  onlyNumbers($event: any) {
    let tecla = $event.keyCode || $event.which;
    if ((tecla > 47 && tecla < 58)) return true;
    else {
      if (tecla == 8 || tecla == 0) return true;
      else return false;
    }
  }

  verificarDDD(inputtelefone) {
    if(this.model.ddd != undefined) {
      if(this.model.ddd.length == 2) {
        inputtelefone.focus();
      }
    }
  }

  verificarTelefone(inputdigitos) {    
      inputdigitos.focus();    
  }  

  public gravaLog(_method) {
    var modelLog = {
      DevedorId: 0,
      DevedorNome: "",
      IP: "",
      URL: APPCONFIG.server + this._logSistema._language + "/api/login/",
      Verb: "GET",
      Token: "",
      Method: _method,
      RequestBody: "",
      ResponseBody: "",
      StatusCode: 200,
      RequestStart: new Date(),
      RequestEnd: new Date(),
      Duration: 0,
      Json: "",
    };
    var _currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
    modelLog.DevedorId = _currentUser.devId;
    modelLog.DevedorNome = _currentUser.nome;
    modelLog.Token = _currentUser.token;
    modelLog.Json = JSON.stringify(modelLog);
    modelLog.RequestBody = modelLog.Json;

    this._logSistema.post("/api/logsistema", modelLog).subscribe(result => {
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/login/login.component.ts